'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _listeners = require('../utils/listeners');

var _functional = require('../utils/functional');

var _tracking = require('../utils/tracking');

var _lazyImages = require('../setup/lazy-images');

var _wishlistButton = require('./wishlist-button');

var _backinstockButton = require('./backinstock-button');

var _helpers = require('./_helpers');

var _collectionFilters = require('./collection-filters');

var _drawerFilters = require('./drawer-filters');

var _drawerSort = require('./drawer-sort');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  CONTAINER_LOADING: 'ldn-Container-active',
  HEADER_TALL: 'pg-Header-tall'
};

var selectors = {
  TOP_FILTERS: '[data-collection-filters-top]',
  DRAWER_FILTERS: '[data-collection-filters-drawer]',
  DRAWER_SORT: '[data-collection-sort-drawer]',
  SEARCH_FORM: '[data-collection-search-form]'
};

var tracking = {
  CATEGORY: 'Collection',
  ACTION_FILTER: 'Filter',
  ACTION_SORT: 'Sort By',
  ACTION_LOAD_MORE: 'Load More',
  ACTION_NO_RESULTS: 'No Results'
};

var CollectionGrid = function () {
  function CollectionGrid(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, CollectionGrid);

    this.el = el;
    this.context = context;

    this.setupSearch();
    this.setupFilters();
    this.setupListeners();

    this._loading = false;
    this._buttonLoading = false;
    this._hasBeenClicked = false;
    this._showPagination = this.initialState.showPagination;
    this._loadedProductsQuantity = Math.min(this.initialState.totalItems, this.initialState.perPage);

    this.searchQuery = this.initialState.searchQuery;
    this.tags = this.initialState.tags;
    this.sort = this.initialState.sort;
    this.currentPage = this.initialState.currentPage;
    this.loadingPage = this.currentPage;
    this.totalItems = this.initialState.totalItems;
    this.loadingPageContent = null;
  }

  (0, _createClass3.default)(CollectionGrid, [{
    key: 'setupFilters',
    value: function setupFilters() {
      var collectionFilters = (0, _functional.getElement)(selectors.TOP_FILTERS);
      var drawerFilters = (0, _functional.getElement)(selectors.DRAWER_FILTERS);
      var sortFilters = (0, _functional.getElement)(selectors.DRAWER_SORT);

      if (collectionFilters) {
        this.collectionFilters = new _collectionFilters.CollectionFilters({
          el: collectionFilters,
          context: (0, _helpers.createContext)(collectionFilters)
        });
      }

      if (drawerFilters) {
        this.drawerFilters = new _drawerFilters.DrawerFilters({
          el: drawerFilters,
          context: (0, _helpers.createContext)(drawerFilters)
        });
      }

      if (sortFilters) {
        this.sortFilters = new _drawerSort.DrawerSort({
          el: sortFilters,
          context: (0, _helpers.createContext)(sortFilters)
        });
      }
    }
  }, {
    key: 'setupSearch',
    value: function setupSearch() {
      this.searchForm = this.els.searchForm;
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      if (this.collectionFilters) {
        this.listeners.add(this.collectionFilters.el, 'filterChange', this.onFilterChange.bind(this));
      }

      if (this.drawerFilters) {
        this.listeners.add(this.drawerFilters.el, 'filterChange', this.onFilterChange.bind(this));
      }

      if (this.sortFilters) {
        this.listeners.add(this.sortFilters.el, 'filterChange', this.onFilterChange.bind(this));
      }

      if (this.searchForm) {
        this.listeners.add(this.searchForm, 'submit', this.onSearch.bind(this));
      }

      this.listeners.add(this.els.loadMoreButton, 'click', this.onClick.bind(this));
    }
  }, {
    key: 'onSearch',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(evt) {
        var formData, eventSearch, titleText;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                evt.preventDefault();
                this.reset();
                this.els.searchInput.blur();

                formData = new FormData(this.searchForm);

                this.searchQuery = formData.get('q');

                eventSearch = new Event('search');

                eventSearch.payload = {
                  search_term: formData.get('q')
                };
                document.dispatchEvent(eventSearch);

                _context.next = 10;
                return this.fetchResults();

              case 10:
                titleText = this.els.headerTitle.dataset.template.replace('{{ count }}', this.totalItems).replace('{{ terms }}', this.searchQuery);

                this.els.header.classList.toggle(classes.HEADER_TALL, this.totalItems === 0);
                this.els.headerTitle.innerHTML = titleText;
                this.els.headerText.style.display = this.totalItems > 0 ? 'none' : 'block';

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSearch(_x) {
        return _ref2.apply(this, arguments);
      }

      return onSearch;
    }()
  }, {
    key: 'onFilterChange',
    value: function onFilterChange(_ref3) {
      var _ref3$detail = _ref3.detail,
          tags = _ref3$detail.tags,
          sort = _ref3$detail.sort;

      this.reset();
      var previousTags = [].concat((0, _toConsumableArray3.default)(this.tags));
      var previousSort = this.sort;

      this.tags = tags || this.tags;
      this.sort = sort || this.sort;

      if ((0, _stringify2.default)(previousTags) !== (0, _stringify2.default)(this.tags)) {
        (0, _tracking.trackGtag)({
          eventCategory: tracking.CATEGORY,
          eventAction: tracking.ACTION_FILTER,
          eventLabel: this.tags.join('|')
        });
      }

      if (previousSort !== this.sort) {
        (0, _tracking.trackGtag)({
          eventCategory: tracking.CATEGORY,
          eventAction: tracking.ACTION_SORT,
          eventLabel: this.sort
        });
      }

      this.fetchResults();
    }
  }, {
    key: 'onClick',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref5) {
        var target = _ref5.target;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.buttonLoading) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                if (!(this.currentPage !== this.loadingPage)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:

                this.hasBeenClicked = true;
                this.buttonLoading = true;
                this.loadingPage = this.currentPage + 1;

                target.blur();
                _context2.next = 10;
                return this.fetchNewPage();

              case 10:

                this.buttonLoading = false;
                this.hasBeenClicked = false;
                this.currentPage = this.loadingPage;

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onClick(_x2) {
        return _ref4.apply(this, arguments);
      }

      return onClick;
    }()
  }, {
    key: 'emptyContent',
    value: function emptyContent() {
      this.els.gridContainer.innerHTML = '';
    }
  }, {
    key: 'insertContent',
    value: function insertContent(content) {
      // Set up the add to cart forms before adding it to the DOM
      window.BAOCart.setupAddToCartForms('.js-AddToCart', content);

      // Set up the wishlist and back in stock buttons
      (0, _wishlistButton.setupWishlistButtons)(content);
      (0, _backinstockButton.setupBackInStockButtons)(content);

      this.els.gridContainer.appendChild(content);

      // Need to manually add the new images to the lazy-loading listener
      // This needs to happen after loading has been set to false
      (0, _lazyImages.updateImages)();
      (0, _lazyImages.setImages)();

      // Second one is to take into account content shifting
      setTimeout(function () {
        (0, _lazyImages.updateImages)();
        (0, _lazyImages.setImages)();
      }, 210);
    }
  }, {
    key: 'fetchResults',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var queryParams, fetchUrl, response, html, _getProductsFromHtml, products, quantity, totalItems;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;
                this.noResults = false;
                this.emptyContent();

                queryParams = this.tags.join('+');
                // eslint-disable-next-line compat/compat

                fetchUrl = new URL('' + location.origin + this.initialState.collectionUrl + '/' + queryParams);

                if (this.searchQuery) {
                  fetchUrl.searchParams.set('q', this.searchQuery);
                  fetchUrl.searchParams.set('type', 'product');
                }

                if (this.sort) {
                  fetchUrl.searchParams.set('sort_by', this.sort);
                }

                _context3.next = 9;
                return fetch(fetchUrl);

              case 9:
                response = _context3.sent;
                _context3.next = 12;
                return response.text();

              case 12:
                html = _context3.sent;
                _getProductsFromHtml = this.getProductsFromHtml(html), products = _getProductsFromHtml.products, quantity = _getProductsFromHtml.quantity, totalItems = _getProductsFromHtml.totalItems;

                this.loading = false;
                this.insertContent(products);
                this.updateUrl(fetchUrl);
                this.totalItems = totalItems;
                this.loadedProductsQuantity = quantity;
                this.noResults = !quantity;

                if (quantity === 0) {
                  (0, _tracking.trackGtag)({
                    eventCategory: tracking.CATEGORY,
                    eventAction: tracking.ACTION_NO_RESULTS,
                    nonInteraction: 1
                  });
                }

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchResults() {
        return _ref6.apply(this, arguments);
      }

      return fetchResults;
    }()
  }, {
    key: 'fetchNewPage',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var queryParams, fetchUrl, response, html, _getProductsFromHtml2, products, quantity;

        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                queryParams = this.tags.join('+');
                // eslint-disable-next-line compat/compat

                fetchUrl = new URL('' + location.origin + this.initialState.collectionUrl + '/' + queryParams);

                fetchUrl.searchParams.set('page', this.loadingPage);

                if (this.searchQuery) {
                  fetchUrl.searchParams.set('q', this.searchQuery);
                  fetchUrl.searchParams.set('type', 'product');
                }

                if (this.sort) {
                  fetchUrl.searchParams.set('sort_by', this.sort);
                }

                _context4.next = 7;
                return fetch(fetchUrl);

              case 7:
                response = _context4.sent;
                _context4.next = 10;
                return response.text();

              case 10:
                html = _context4.sent;
                _getProductsFromHtml2 = this.getProductsFromHtml(html), products = _getProductsFromHtml2.products, quantity = _getProductsFromHtml2.quantity;

                this.loadedProductsQuantity += quantity;
                this.insertContent(products);

                (0, _tracking.trackGtag)({
                  eventCategory: tracking.CATEGORY,
                  eventAction: tracking.ACTION_LOAD_MORE,
                  eventValue: this.loadingPage
                });

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function fetchNewPage() {
        return _ref7.apply(this, arguments);
      }

      return fetchNewPage;
    }()
  }, {
    key: 'getProductsFromHtml',
    value: function getProductsFromHtml(html) {
      var fragment = document.createDocumentFragment();
      var div = (0, _functional.createElement)('div');
      div.innerHTML = html;

      var newElements = (0, _functional.getElements)(this.initialState.itemClassName, { context: div });
      // TODO: Remove hard coded classname
      var collectionGridModule = (0, _functional.getElement)('.clc-List', { context: div });

      newElements.forEach(function (item, index) {
        fragment.appendChild(item);
      });

      return {
        products: fragment,
        quantity: newElements.length,
        totalItems: parseInt(collectionGridModule.dataset.totalItems, 10)
      };
    }

    // Updates the address bar with the new filters

  }, {
    key: 'updateUrl',
    value: function updateUrl(newUrl) {
      // TODO: Improve state push
      history.pushState({}, '', newUrl);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.currentPage = this.loadingPage = 1;
    }
  }, {
    key: 'initialState',
    get: function get() {
      return {
        collectionUrl: this.el.dataset.collectionUrl,
        currentPage: parseInt(this.el.dataset.currentPage, 10),
        totalItems: parseInt(this.el.dataset.totalItems, 10),
        perPage: parseInt(this.el.dataset.perPage, 10),
        showPagination: Boolean(this.el.dataset.showPagination),

        searchQuery: this.el.dataset.searchQuery,
        tags: this.el.dataset.tags ? this.el.dataset.tags.split('+') : [],
        sort: this.el.dataset.sort,

        itemClassName: this.el.dataset.itemClassName,

        paginationTextTemplate: this.el.dataset.textTemplate
      };
    }
  }, {
    key: 'els',
    get: function get() {
      var els = {
        el: this.el,
        gridContainer: this.context.getElement('.' + this.context.className + '_Target'),
        noResultsContainer: this.context.getElement('.' + this.context.className + '_Empty'),
        loadMoreButton: this.context.getElement('.' + this.context.className + '_Trigger'),
        pagination: this.context.getElement('.' + this.context.className + '_Pagination'),
        paginationText: this.context.getElement('.' + this.context.className + '_Text')
      };

      var header = (0, _functional.getElement)('.' + this.context.className + '_Header');

      if (header) {
        els = (0, _assign2.default)({}, els, {
          header: header,
          headerTitle: (0, _functional.getElement)('.' + this.context.className + '_Title', {
            context: header
          }),
          headerText: (0, _functional.getElement)('.' + this.context.className + '_Text', {
            context: header
          })
        });
      }

      var searchForm = (0, _functional.getElement)(selectors.SEARCH_FORM);

      if (searchForm) {
        els = (0, _assign2.default)({}, els, {
          searchForm: searchForm,
          searchInput: (0, _functional.getElement)('.' + this.context.className + 'Search_Input', {
            context: searchForm
          })
        });
      }

      return els;
    }
  }, {
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      this.el.classList.toggle(classes.CONTAINER_LOADING, val);
      this.els.pagination.style.display = val ? 'none' : 'block';
    }
  }, {
    key: 'buttonLoading',
    get: function get() {
      return this._buttonLoading;
    },
    set: function set(val) {
      this._buttonLoading = val;

      this.el.classList.toggle('js-LoadMore-loading', val);
    }
  }, {
    key: 'noResults',
    set: function set(val) {
      if (this.els.noResultsContainer) {
        this.els.noResultsContainer.style.display = val ? 'block' : 'none';
      }
    }
  }, {
    key: 'showPagination',
    get: function get() {
      return this._showPagination;
    },
    set: function set(val) {
      this._showPagination = val;

      this.els.pagination.style.display = val ? 'block' : 'none';
    }
  }, {
    key: 'loadedProductsQuantity',
    get: function get() {
      return this._loadedProductsQuantity;
    },
    set: function set(val) {
      this._loadedProductsQuantity = val;

      this.els.paginationText.innerText = this.initialState.paginationTextTemplate.replace('{{ pagination_amount }}', this._loadedProductsQuantity).replace('{{ total_count }}', this.totalItems);

      this.els.pagination.style.display = val >= this.totalItems ? 'none' : 'block';
    }
  }]);
  return CollectionGrid;
}();

var init = exports.init = function init(_ref8) {
  var el = _ref8.el,
      context = _ref8.context;

  return new CollectionGrid({ el: el, context: context });
};